type AppMode = 'LOCAL' | 'STAGING' | 'PROD'

function parseChainId(value: string | undefined, fallback: number): number {
    const n = Number(value)
    return Number.isInteger(n) && n > 0 ? n : fallback
}

function parseAppMode(value: string | undefined): AppMode {
    if (value === 'STAGING' || value === 'PROD') return value
    return 'LOCAL'
}

export const ENV = {
    GAMING_SERVICE_URL: import.meta.env.VITE_GAMING_SERVICE_URL ?? 'http://localhost:8080',
    WALLETCONNECT_PROJECT_ID: import.meta.env.VITE_WALLETCONNECT_PROJECT_ID ?? '',
    APP_MODE: parseAppMode(import.meta.env.VITE_APP_MODE),

    // Per-chain contract addresses live in src/constants/contract-addresses/*.ts
    // (synced by scripts/sync-addresses.mjs), not env vars. Only the RPC endpoint
    // stays env-driven so one build can target localhost or a public RPC without
    // rebuilding.
    TESTNET_RPC_URL: (import.meta.env.VITE_TESTNET_RPC_URL ?? 'https://sepolia.base.org') as string,
    // Which testnet the STAGING/PROD build targets. Base Sepolia (84532) is the only
    // supported one. Also selects the CHAINS_CONFIG entry the Dockerfile syncs
    // addresses from.
    TESTNET_CHAIN_ID: parseChainId(import.meta.env.VITE_TESTNET_CHAIN_ID, 84532),
}
